import React from "react";
import "./style.scss";

const Content = ({ content, children, classname }) => {
  return (
    <div className={`content ${classname}`}>
      {children}
      <div>{content}</div>
    </div>
  );
};

export default Content;
